'use client';
/**
 * /search 결과 페이지 확정 섬(s-log) — 화면에는 아무것도 그리지 않는다(모든 UA 같은 HTML · 서버 HTML 에 기록 id 없음).
 *   · 마운트 1회: 서버 렌더가 남긴 search_logs 행을 이 세션(sessionStorage 난수) · 선택 지역(기억)으로 확정 → 행 id.
 *     JS 를 돌리지 않는 요청(크롤러)은 확정되지 않는다 → 매일 학습 틱이 bot_type 'nojs' 로 판정.
 *     0건(또는 근접만 노출 near)이면 서버가 search_misses 1행(사람만).
 *   · 결과 클릭: [data-kds="results"] 안 결과 링크(a.sr · a.pr · .rgs a · [data-search-result]) 화면 순서 = 순위 →
 *     같은 행 update(clicked_rank · selected_slug). 현장(/apt/{slug})은 slug, 그 밖은 경로.
 * 지역: URL ?region= 가 있으면 그것, 없으면 지역 기억(readRegionMemory). 둘 다 없으면 null → 학습 5 가 클릭한 현장 지역으로 보정.
 */
import { useEffect, useRef } from 'react';
import { confirmPage, logResultClick } from '@/lib/search/log-client';
import { slugFromHref } from '@/lib/search/log-core';
import { readRegionMemory } from '@/lib/nav/region-scope';

const RESULT_SEL = 'a.sr, a.pr, .rgs a, a[data-search-result]';

export default function SearchConfirmLogger({ q, count, source, near = false }: { q: string; count: number; source: string; near?: boolean }) {
  const idRef = useRef<Promise<string | null> | null>(null);

  useEffect(() => {
    let region: string | null = null;
    try {
      const r = new URLSearchParams(window.location.search).get('region');
      region = r && /^[0-9]{2,5}$/.test(r) ? r : readRegionMemory();
    } catch { region = null; }
    idRef.current = confirmPage({ q, count, source, region, near });

    const root = document.querySelector('[data-kds="results"]') ?? document;
    const onClick = (e: Event) => {
      const a = (e.target as Element | null)?.closest?.(RESULT_SEL) as HTMLAnchorElement | null;
      if (!a) return;
      const list = Array.from(root.querySelectorAll<HTMLAnchorElement>(RESULT_SEL));
      const rank = list.indexOf(a) + 1;
      const slug = slugFromHref(a.getAttribute('href'));
      void idRef.current?.then((id) => logResultClick(id, slug, rank));
    };
    root.addEventListener('click', onClick);
    return () => root.removeEventListener('click', onClick);
  }, [q, count, source, near]);

  return null;
}
